import { render } from "./UpdateConsentPage.vue?vue&type=template&id=2f9c0b9c&ts=true"
import script from "./UpdateConsentPage.vue?vue&type=script&lang=ts"
export * from "./UpdateConsentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Consent/UpdateConsentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f9c0b9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f9c0b9c', __exports__)) {
    api.reload('2f9c0b9c', __exports__)
  }
  
  module.hot.accept("./UpdateConsentPage.vue?vue&type=template&id=2f9c0b9c&ts=true", () => {
    api.rerender('2f9c0b9c', render)
  })

}


export default __exports__